import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 0 3px !important;
  padding-top: 5px !important;
`;

const Letter = styled.h2`
  all: initial;
  color: #72888E !important;
  font-size: 70px !important;
  letter-spacing: -1.1px;
  margin-bottom: 15px;
  font-weight: 500 !important;
  text-align: left;
`;

const Item = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }

  margin-bottom: 8px;
  cursor: pointer;
  width: 100%;
  border: none;
  background-color: transparent;
  padding: 0px 2px;
`;

const Text = styled.p`
  all: initial;
  color: #404040 !important;
  font-size: 15px !important;
  display: block;
  cursor: pointer;
  padding: 3px 0;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const ListItem = ({ letter, materials, onClick }) => (
  <Container>
    {
      letter
        ? (
          <Letter aria-label={letter}>
            {letter}
          </Letter>
        ) : null
    }
    {
      materials.length
        ? (
          materials.map((material) => (
            <Item
              tabIndex="0"
              role="link"
              key={material.id}
              onClick={() => onClick(material.id)}
            >
              <Text aria-label={material.name} title={material.name} tabIndex="-1">
                {material.name}
              </Text>
            </Item>
          ))
        ) : null
    }
  </Container>
);

export default ListItem;
